<header class="w-full h-16 flex items-center justify-between px-4 border-b border-extend-border bg-extend-primary text-extend-onPrimary">
  <div class="flex items-center gap-3">
    <!-- Hamburger icon (Font Awesome) -->
    <button type="button" class="p-2 rounded focus:outline-none" (click)="onToggle()" aria-label="Toggle navigation" [attr.aria-expanded]="showSideNav">
      <i class="fas fa-bars text-xl" aria-hidden="true"></i>
    </button>
    <!-- App name
    <div class="text-2xl select-none">Q-Wizard</div>-->
  </div>

  <div class="flex items-center gap-4">
    <!-- Magnifying glass icon (Font Awesome)
    <button type="button" class="p-2 rounded" aria-label="Search">
      <i class="fas fa-search text-xl" aria-hidden="true"></i>
    </button>

    <button type="button" class="p-2 rounded" aria-label="Notifications">
      <i class="fas fa-bell text-xl" aria-hidden="true"></i>
    </button>
     -->
    <div class="relative">
      <div class="h-11 w-11 rounded-full bg-extend-background border border-extend-border flex items-center justify-center text-lg text-extend-onGrayPrimary select-none cursor-pointer overflow-hidden" 
           (click)="toggleUserMenu($event)" title="User">
        @if (!userProfile?.attributes?.['picture']) {
          <i class="fas fa-user" aria-hidden="true"></i>
        }
        @if (userProfile?.attributes?.['picture']) {
          <img [src]="userProfile?.attributes?.['picture']" alt="User Profile">
        }
      </div>

      <!-- User Dropdown Menu -->
      @if (showUserMenu) {
        <div class="absolute right-0 mt-2 w-64 bg-white rounded-md shadow-lg border border-gray-200 z-50 text-gray-800">
          <div class="p-4 border-b border-gray-100 flex items-center gap-3">
            <div class="h-12 w-12 rounded-full bg-gray-100 flex items-center justify-center text-gray-400 overflow-hidden shrink-0">
              @if (!userProfile?.attributes?.['picture']) {
                <i class="fas fa-user text-xl"></i>
              }
              @if (userProfile?.attributes?.['picture']) {
                <img [src]="userProfile?.attributes?.['picture']" alt="User Profile">
              }
            </div>
            <div class="overflow-hidden">
              <div class="font-bold truncate text-sm" [title]="userProfile?.username">{{ userProfile?.username }}</div>
              <div class="text-xs text-gray-500 truncate" [title]="userProfile?.email">{{ userProfile?.email }}</div>
            </div>
          </div>
          
          <div class="py-2">
            <div class="px-4 py-1 text-xs font-semibold text-gray-500 uppercase tracking-wider">
              Account
            </div>
            <a href="/account/settings" class="flex items-center gap-3 px-4 py-2 text-sm hover:bg-gray-50 transition-colors">
              <i class="fas fa-cog text-gray-400 w-4"></i>
              <span>Settings</span>
            </a>
          </div>
          
          <div class="py-1 border-t border-gray-100">
            <button (click)="logout()" class="w-full flex items-center gap-3 px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors">
              <i class="fas fa-sign-out-alt w-4"></i>
              <span>Logout</span>
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</header>
